import { render, staticRenderFns } from "./BAlert.vue?vue&type=template&id=5f29e9dd&scoped=true"
import script from "./BAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./BAlert.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BAlert.vue?vue&type=style&index=0&id=5f29e9dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f29e9dd",
  null
  
)

export default component.exports